import { Navigate } from "react-router-dom"
import { AppLayout } from "../layout";
import { Simulator } from "../pages/simulator";
import { UploadDocument } from "../pages/uploadDocument";
import { OrderPending } from "../pages/order/pending";
import { OrderReproved } from "../pages/order/reproved";
import { RentDetails } from "../pages/rent";
import { Signature } from "../pages/order/signature";
import { Dashboard } from "../pages/dashboard";
import { History } from "../pages/dashboard/tabs/rent/components/history";
import { Login } from "../pages/login";
import { AnimationLayout } from "../layout/animation";
import { Register } from "../pages/register";
import { UploadSerasaDocument } from "../pages/order/serasa";
import { ManualPhotos } from "../pages/photos";
import { ManualBusinessPhotos } from "../pages/businesPhotos";

const ClientRouters = [
    {
        path: "/cliente",
        element: <AppLayout />,
        children: [
            {
                element: <Dashboard />,
                path: "/cliente/",
            },
            {
                element: <Simulator />,
                path: "/cliente/simulador",
            },
            {
                element: <UploadDocument />,
                path: "/cliente/upload-documento",
            },
            {
                element: <OrderPending />,
                path: "/cliente/pedido-enviado",
            },
            {
                element: <OrderReproved />,
                path: "/cliente/pedido-reprovado",
            },
            {
                element: <RentDetails />,
                path: "/cliente/locacao",
            },
            {
                element: <History />,
                path: "/cliente/locacao/historico",
            },
            {
                element: <RentDetails />,
                path: "/cliente/locacao/:id",
            },
            {
                element: <Signature />,
                path: "/cliente/assinatura",
            },
            {
                element: <UploadSerasaDocument />,
                path: "/cliente/serasa",
            },
            {
                element: <ManualPhotos />,
                path: "/cliente/fotos",
            },
            {
                element: <ManualBusinessPhotos />,
                path: "/cliente/fotos-da-empresa",
            },
            {
                element: <Navigate to="/cliente/" />,
                path: "/cliente/*",
            },
        ]
    },
    {
        element: <Login isClient={false} />,
        path: "/parceiro/login",
    },
    {
        element: <Navigate to="/parceiro/login" />,
        path: "/parceiro/*",
    },
    {
        element: <AnimationLayout />,
        children: [
            {
                element: <Register isClient={false} />,
                path: "/parceiro/cadastro",
            },
        ]
    }
]

export default ClientRouters;